var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import colors from '../../themes/colors';
export default styled.tr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  z-index: 1;\n  height: 1px;\n  position: absolute;\n  width: calc(100% - 32px);\n  margin: 0 16px;\n"], ["\n  background-color: ", ";\n  z-index: 1;\n  height: 1px;\n  position: absolute;\n  width: calc(100% - 32px);\n  margin: 0 16px;\n"])), colors.neutral10);
var templateObject_1;
